/**
 * Metadata key for storing event handler metadata on methods.
 */
export const MATADOR_EVENT_HANDLER = Symbol('MATADOR_EVENT_HANDLER');

/**
 * Metadata key for storing a list of all event handlers on a class.
 */
export const MATADOR_EVENT_HANDLERS = Symbol('MATADOR_EVENT_HANDLERS');

/**
 * Injection token for module options.
 */
export const MATADOR_OPTIONS = Symbol('MATADOR_OPTIONS');
